<p-accordion>
  <p-accordionTab header="Source" [selected]="true">
    <p-table #db [value]="oppSources" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditOppData(data, oppDataTypes[0])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="delOppSource(data)" pTooltip="Delete" tooltipPosition="top"><i
                class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Quality">
    <p-table [value]="ratings" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditOppData(data, oppDataTypes[1])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="delQuality(data)" pTooltip="Delete" tooltipPosition="top"><i
                class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Close Won Reason">
    <p-table [value]="closeWonReasons" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditOppData(data, oppDataTypes[2])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="deleteCloseReason(data, oppDataTypes[2])" pTooltip="Delete"
              tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Close Lost Reason">
    <p-table [value]="closeLostReasons" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditOppData(data, oppDataTypes[3])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="deleteCloseReason(data, oppDataTypes[3])" pTooltip="Delete"
              tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Active Reason">
    <p-table [value]="activeReason" [scrollable]="true" scrollHeight="180px">
        <ng-template pTemplate="header">
            <tr>
                <th class="p-col-6">Name</th>
                <th class="p-col-2">Is Active</th>
                <th class="p-col-2">Is Default</th>
                <th class="p-col-2">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr style="cursor: move;">
                <td class="p-col-6">{{ data.name }}</td>
                <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                <td class="p-col-2">
                    <p-radioButton [disabled]="data.statusId!=1 || data.isDefault" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                    {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                </td>
                <td class="p-col-2 action">
                    <span class="btnBars p-mr-0" (click)="showEditOppData(data, oppDataTypes[4])" pTooltip="Edit"
                        tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                    <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, oppDataTypes[4])"
                        pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i class="pi pi-trash"></i></span>
                </td>
            </tr>
        </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Inactive Reason">
    <p-table [value]="inactiveReason" [scrollable]="true" scrollHeight="180px">
        <ng-template pTemplate="header">
            <tr>
                <th class="p-col-6">Name</th>
                <th class="p-col-2">Is Active</th>
                <th class="p-col-2">Is Default</th>
                <th class="p-col-2">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr style="cursor: move;">
                <td class="p-col-6">{{ data.name }}</td>
                <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                <td class="p-col-2">
                    <p-radioButton [disabled]="data.statusId!=1 || data.isDefault" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                    {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                </td>
                <td class="p-col-2 action">
                    <span class="btnBars p-mr-0" (click)="showEditOppData(data, oppDataTypes[5])" pTooltip="Edit"
                        tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                    <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, oppDataTypes[5])"
                        pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i class="pi pi-trash"></i></span>
                </td>
            </tr>
        </ng-template>
    </p-table>
  </p-accordionTab>
</p-accordion>


<p-dialog header="{{addEditOppHeader}}" [(visible)]="displayAddOppData" [style]="{width: '50vw'}" [baseZIndex]="10000"
  (onHide)="cancelOppDataAdd(testForm)">
  <form #testForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12" *ngIf="addEditOppHeader == 'Add Field Data'">
        <label for="type">Fields Type <span style="color: red;">*</span></label>
        <p-dropdown [options]="oppDataTypes" [(ngModel)]="selectedOppDataType" optionLabel="name"
          placeholder="Select Field Type" [ngModelOptions]="{standalone:
        true}" appendTo="body" ></p-dropdown>
      </div>
      <div class="p-col-12" *ngIf="addEditOppHeader == 'Edit Field Data'">
        <h5 class="p-mb-0">Fields Name -- {{oppDataTypes[oppTypeId].name}}</h5>
      </div>
      <div class="p-col-12">
          <label for="name">Name <span style="color: red;">*</span></label>
          <input 
              type="text" 
              [ngModelOptions]="{standalone: true}" 
              pInputText 
              [ngModel]="oppDataTemp?.name" 
              #dataName="ngModel" 
              [ngClass]="{ 'p-invalid': showValidation && !oppDataTemp.name}"
              (ngModelChange)="oppDataTemp.name= $event">
          <small 
              *ngIf="showValidation && !oppDataTemp.name" 
              class="p-invalid">
            Name is required
          </small>

          <small *ngIf="invalidData == true" class="p-invalid">
            Name exists in the list already
          </small>
      </div>
      <div class="p-col-12">
        <label for="name">Description</label>
        <input type="text" [ngModelOptions]="{standalone: true}" pInputText style="width: 100%;"
        [ngModel]="oppDataTemp?.description" (ngModelChange)="oppDataTemp.description= $event">
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddOppData=false;invalidData=false;" label="Cancel"
      class="p-button-secondary" (click)="cancleAddEditFieldData();"></button>
    <button pButton (click)="saveOppDataAdd()" label="Save"></button>
  </ng-template>
</p-dialog>


<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
